import React, { useEffect } from 'react';
import { ContainerOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { Avatar, Image, Typography } from 'antd';
import { isArray, split } from 'lodash';
import { BASE_IMG, urlPath } from '@/utils/CommonUtils';
import { dataId } from '@/utils/types/common';
import { AvatarProps } from 'antd/es/avatar/Avatar';
import AdminFile from '@/services/admin/Base/AdminBaseFile';
import { UploadVo } from '@/services/admin/AdminTypings';
import { fileUrl, fileUrlList } from '@/utils/FileUtils';

declare type AvatarViewerProps = AvatarProps & {
  avatar: dataId;
};

export const AvatarViewer: React.FC<AvatarViewerProps> = (props: AvatarViewerProps) => {
  const { avatar, ...rest } = props || {};
  const [url, setUrl] = React.useState<string | undefined>(undefined);

  const getAvatar = async () => {
    const data: UploadVo | undefined = await fileUrl(avatar);
    if (!data) {
      setUrl(undefined);
      return;
    }
    setUrl(data.url);
  };

  useEffect(() => {
    getAvatar();
  }, [avatar]);

  // @ts-ignore
  return <Avatar src={<Image fallback={BASE_IMG} src={url} />} {...rest} />;
};

declare type ImageViewerProps = {
  value: any;
  multiple?: boolean;
};

export const ImageViewer: React.FC<ImageViewerProps> = (props: ImageViewerProps) => {
  const { value, multiple = false } = props || {};
  const [files, setFiles] = React.useState<string[] | undefined>([]);

  const multipleFiles = async () => {
    let ids = value;
    if (!isArray(value)) {
      ids = split(value, ',');
    }
    if (!isArray(ids)) {
      setFiles([]);
      return;
    }
    const urlList: UploadVo[] | undefined = await fileUrlList(ids);
    const data = (urlList || []).map((v) => {
      return v.url;
    });
    // @ts-ignore
    setFiles(data);
  };

  const singleFiles = async () => {
    const data = await AdminFile.urlList(value);
    if (!data) {
      setFiles([]);
      return;
    }
    // @ts-ignore
    setFiles([data.privateRead ? urlPath(`/sys${data.url}`) : data.url]);
  };

  const getFiles = () => {
    if (!multiple) {
      multipleFiles();
      return;
    }

    singleFiles();
  };

  useEffect(() => {
    getFiles();
  }, []);

  return (
    <Image.PreviewGroup items={files || []}>
      <Image
        style={{
          borderRadius: '10px',
          display: 'inline-block',
          margin: '0 auto',
          maxWidth: '60px',
          maxHeight: '60px',
        }}
        fallback={BASE_IMG}
        src={files ? files[0] : undefined}
      />
    </Image.PreviewGroup>
  );
};

declare type FileViewerProps = {
  value: any;
  isImage?: boolean;
  multiple?: boolean;
};

export const FileViewer: React.FC<FileViewerProps> = (props: FileViewerProps) => {
  const { value, isImage = false, multiple = false } = props || {};

  if (isImage) {
    return <ImageViewer value={value} multiple={multiple} />;
  }
  if (multiple) {
    return (
      <Typography.Text>
        <FolderOpenOutlined
          style={{
            fontSize: '18px',
            color: '#87d068',
          }}
        />
        多文件
      </Typography.Text>
    );
  }
  return (
    <Typography.Text>
      <ContainerOutlined
        style={{
          fontSize: '18px',
          color: '#87d068',
        }}
      />
      文件
    </Typography.Text>
  );
};
